import {IElementWedlet, IWedlet} from "/@back@/edit/wed/wedlets/wedlet.js";
import {isWedletSingleElt} from "/@back@/edit/wed/wedlets/wedletSingleElt.js";
import {IJmlNode} from "/@lib@/commons/xml/jml.js";

/**
 *  Recherche la valeur d'un attribut dans l'élément racine des ascendants du wedlet courant
 *    <box-up-property name="placeholder" upSelector="down:4"/>
 *  Selecteur :
 *      upSelector="5"         att spécifié en remontant 5 niveaux
 *      upSelector="down:4"    premier att non vide en partant de la position 4, et en redescendant jusqu'à la position courant
 *      upSelector="down:4:2"  premier att non vide en partant de la position 4, et en redescendant jusqu'à la position 2
 *      upSelector="up:2:4"    premier att non vide en partant de la position 2, et en remontant jusqu'à la position 4
 */
export class BoxUpProperty extends HTMLElement implements IElementWedlet {

	wedlet: IWedlet;

	propertyName: string;

	upSelector: string;

	constructor() {
		super();
		this.style.userSelect = "none";
	}

	configWedletElt(tpl: Element, wedlet: IWedlet) {
		this.wedlet = wedlet;
		this.propertyName = tpl.getAttribute("name");
		this.upSelector = tpl.getAttribute("upSelector");
	}

	refreshBindValue(val: IJmlNode) {
		this.textContent = findAttributeValue(this.wedlet, this.propertyName, this.upSelector);
	}
}

window.customElements.define("box-up-property", BoxUpProperty);

function findAttributeValue(wedlet: IWedlet, attributeName: string, upSelector: string) {
	const axePos = upSelector.indexOf(":");
	if (axePos != -1) {
		const axe = upSelector.substring(0, axePos);
		let minLevel;
		let maxLevel;
		const bounds = upSelector.substring(axePos + 1);
		if (bounds.indexOf(":") > -1) {
			minLevel = parseInt(bounds.substring(0, bounds.indexOf(":")), 10);
			maxLevel = parseInt(bounds.substring(bounds.indexOf(":") + 1), 10);
		} else {
			minLevel = 0;
			maxLevel = parseInt(bounds, 10);
		}
		switch (axe) {
		case "down" :
			for (let i = 0; wedlet && i < minLevel; i++) wedlet = wedlet.wedParent;
			let lastFindPlaceholder = "";
			for (let i = minLevel; wedlet && i < maxLevel; i++) {
				wedlet = wedlet.wedParent;
				if (wedlet && isWedletSingleElt(wedlet) && wedlet.element.getAttribute(attributeName))
					lastFindPlaceholder = wedlet.element.getAttribute(attributeName);
			}
			return lastFindPlaceholder;
			break;
		case "up" :
			for (let i = 0; wedlet && i < minLevel; i++) wedlet = wedlet.wedParent;
			for (let i = minLevel; wedlet && i < maxLevel; i++) {
				if (wedlet && isWedletSingleElt(wedlet) && wedlet.element.getAttribute(attributeName)) {
					return wedlet.element.getAttribute(attributeName);
				}
				wedlet = wedlet.wedParent;
			}
			break;
		default :
			throw "axe unknown in : " + upSelector;
		}
	} else {
		const up = parseInt(upSelector, 10);
		for (let i = 0; wedlet && i < up; i++) wedlet = wedlet.wedParent;
		if (wedlet && isWedletSingleElt(wedlet))
			return wedlet.element.getAttribute(attributeName);
	}
}
